import React from 'react'
import {DefaultProps, PaginatedLoad, Refresh, RefTable} from "./RefTable";

export const MassPostSaleWithoutLC = (props)=><RefTable {...props}/>;

MassPostSaleWithoutLC.defaultProps = {
    ...DefaultProps,
    title: "Mass Post Sale w/o LC Log",
    tableSchema: "em_mass_post_sale_without_lc_job_view",
    tableName: "em_mass_post_sale_without_lc_job_view",
    filterSchema:"em_mass_post_sale_without_lc_job_filter",
    edit: false,
    add: false,
    theadHeight: 64,
    tfootHeight: 50,
    customActionElements:[<Refresh key={"refresh-action"}/>],
    fetch: PaginatedLoad
}
